'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

require('./drawer-icon.scss');

var _classnames = require('../../../utils/classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function DrawerIcon(_ref) {
  var open = _ref.open,
      props = _objectWithoutProperties(_ref, ['open']);

  var classes = (0, _classnames2.default)('drawer-icon', 'drawer-icon--spin', open && 'drawer-icon--is-open is-active');

  return _react2.default.createElement(
    'button',
    _extends({ className: classes, type: 'button' }, props),
    _react2.default.createElement(
      'span',
      { className: 'drawer-icon-box' },
      _react2.default.createElement('span', { className: 'drawer-icon-inner' })
    )
  );
}

DrawerIcon.propTypes = {
  open: _propTypes2.default.bool,
  onClose: _propTypes2.default.func
};

DrawerIcon.defaultProps = {
  onClose: function onClose() {
    return null;
  }
};

exports.default = DrawerIcon;